import { hydrateAction } from 'src/redux/actions';
import urls from 'src/urls/source';

import { FetchSource } from './';

type SourceProps = {
  repositoryFullSlug: string;
  refOrHash: string | null | undefined;
};

export default ({ repositoryFullSlug, refOrHash }: SourceProps, at?: string) =>
  hydrateAction(FetchSource, 'repository.source.section', {
    url: urls.ui.source(repositoryFullSlug, {
      refOrHash,
      at,
      applyRouterFix: false,
    }),
  });
